import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--video-player"
export default class extends Controller {
  static targets = ["video"];

  // iframeのsrcを再設定することで動画を停止する
  stop() {
    if (this.hasVideoTarget) {
      const src = this.videoTarget.src;
      this.videoTarget.src = src;
    }
  }
}
